// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientPreferences/Tags/Tags.css
// module id = 1472
// module chunks = 0